import { useEffect, useState } from 'react';

const reduced = typeof window !== 'undefined'
  && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

export default function AnimatedCounter({ to = 0, duration = 700, pad = 0 }) {
  const [n, setN] = useState(reduced ? to : 0);

  useEffect(() => {
    if (reduced) { setN(to); return; }
    let raf;
    const start = performance.now();
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      setN(Math.round(to * eased));
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [to, duration]);

  return <>{pad ? String(n).padStart(pad, '0') : n}</>;
}
